<template>
<div id="add-policy" v-if="editedItem" class="grid">
    <div class="grid-title">
        <h4>{{ $t("PAYMENT_POLICY") }}</h4>
    </div>
    <div class="grid-body p-3 pb-0 border-top-unset">
        <v-form ref="form" lazy-validation v-on:submit.prevent>
            <v-row>
                <v-col sm="12">
                    <label>{{ $t("POLICY_NAME") }} *</label>
                    <v-text-field v-model="editedItem.nameVi" :rules="[rules.required]" outlined dense>
                    </v-text-field>
                </v-col>
                <v-col sm="12" class="pt-0">
                    <label>{{ $t("DESCRIPTION") }}</label>
                    <v-text-field
                        outlined
                        dense
                        v-model="editedItem.descriptionVi"
                        @keydown="handleMaxLength($event, 3000)"
                        @paste="handleMaxLength($event, 3000)"
                    >
                    </v-text-field>
                    <div class="d-flex justify-content-end text-secondary">{{ charCount(editedItem.descriptionVi, 3000) }}</div>
                </v-col>
                <v-col md="12" class="pt-0">
                    <label>{{ $t("PAYMENT_REQUIRED_UPON_BOOKING") }}</label>
                    <v-radio-group row v-model="paymentRequired" class="mt-2">
                        <v-radio color="indigo darken-3" :label="$t('YES')" :value="true"></v-radio>
                        <v-radio color="indigo darken-3" :label="$t('NO')" :value="false"></v-radio>
                    </v-radio-group>
                    <p class="border-bottom pt-3"></p>
                </v-col>
                <v-col md="12" class="pt-0">
                    <p><strong>{{$t('CONDITIONS')}}</strong></p>
                    <div>
                        <template v-if="paymentRequired === false">
                            <div>
                                <label>{{ $t("WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT") }}</label>
                                <v-row>
                                    <v-col md="4">
                                        <v-select :items="select.cusOfDateTypeOption" item-text="text" item-value="value" v-model="editedItem.cutOfDateType" outlined dense class="text" :rules="[rules.select]" @change="changeCusOfDateType()"></v-select>
                                    </v-col>
                                    <v-col>
                                        <vuetify-number v-model="editedItem.cutOfDate" :options="(usedCurrency == 'VND') ? amountOptionsVi : amountOptionsEn" dense :rules="[rules.required, rules.time]" outlined v-if="[3, 4].includes(editedItem.cutOfDateType)" />
                                        <vuetify-number v-model="editedItem.cutOfDate" :options="(usedCurrency == 'VND') ? amountOptionsVi : amountOptionsEn" dense :rules="[rules.required, rules.number]" outlined v-if="[0, 1].includes(editedItem.cutOfDateType)" />
                                    </v-col>
                                    <v-col class="align-midle" v-if="[0, 1, 3, 4].includes(editedItem.cutOfDateType)">
                                        <span>{{$t([3, 4].includes(editedItem.cutOfDateType) ? 'HOUR' : 'DAY')}}</span>
                                    </v-col>
                                </v-row>
                            </div>
                        </template>
                        <template v-if="[0, 1, 2, 3, 4, 6].includes(editedItem.cutOfDateType)">
                            <div>
                                <label>{{ $t([0, 1, 3, 4, 6].includes(editedItem.cutOfDateType) ? "HOW_MUCH_DOES_THE_CUSTOMER_MAKE_PAYMENT":"HOW_MUCH_PAYMENT_IS_MADE_BY_THE_GUEST_ON_THE_DAY_OF_BOOKING") }}</label>
                                <v-row>
                                    <v-col>
                                        <v-select :items="select.unit" item-text="text" item-value="value" v-model="editedItem.chargeType" outlined dense class="text" :rules="[rules.select]" @change="changeRuleAmount()"></v-select>
                                    </v-col>
                                    <v-col>
                                        <vuetify-number v-model="editedItem.amount" :options="(usedCurrency == 'VND') ? amountOptionsVi : amountOptionsEn" dense :rules="[rules.required, rules.maxNight, rules.number]" outlined v-if="editedItem.chargeType == 2" />
                                        <vuetify-number v-model="editedItem.amount" :options="(usedCurrency == 'VND') ? amountOptionsVi : amountOptionsEn" dense :rules="[rules.required, rules.maxPercent, rules.number]" outlined v-if="editedItem.chargeType == 1" />
                                        <v-text-field 
                                            v-model="pricePolicy"
                                            ref="pricePolicy"
                                            :options="amountOptionsVi" 
                                            dense 
                                            :rules="[rules.required, rules.number]" 
                                            outlined 
                                            v-if="editedItem.chargeType == 0"
                                            @keydown="keyCurrencyDown($event, usedCurrency)"
                                            :key="`pricePolicy_${forceRenderKey}`"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col class="align-midle">
                                        <span>{{$t(editedItem.chargeType === 1 ? 'PERCENT_OF_TOTAL_ROOM_RATE' : editedItem.chargeType === 0 ? usedCurrency : 'NIGHT')}}</span>
                                    </v-col>
                                </v-row>
                                <template v-if="(editedItem.chargeType === 1 && +editedItem.amount !== 100) || editedItem.chargeType !== 1">
                                    <div>
                                        <label>{{ $t("WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT_FOR_THE_REMAINING_AMOUNT") }}</label>
                                        <v-row>
                                            <v-col md="4">
                                                <v-select :items="paymentDayTypeOption" item-text="text" item-value="value" outlined dense v-model="editedItem.paymentDayType">
                                                </v-select>
                                            </v-col>
                                            <v-col v-if="[0, 1].includes(editedItem.paymentDayType)" md="4">
                                                <vuetify-number v-model="editedItem.paymentDay" :options="amountOptionsVi" dense :rules="[rules.required, rules.number]" outlined />
                                            </v-col>
                                            <v-col v-if="[0, 1].includes(editedItem.paymentDayType)" class="align-midle"><span>{{$t('DAY')}}</span></v-col>
                                        </v-row>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <v-row>
                            <v-col>
                                <label>{{ $t("WHAT_THE_PAYMENT_POLICY_FOR_THE_BOOKING_PERIOD") }}</label>
                                <v-row>
                                    <v-col md="12" class="pt-0 align-midle">
                                        <v-radio-group row v-model="editedItem.bookingSession" class="mt-2">
                                            <v-radio color="indigo darken-3" :label="$t('ALWAYS')" :value="false"></v-radio>
                                            <v-radio color="indigo darken-3" :label="$t('IN_PERIOD')" :value="true"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    <v-col md="12" class="pt-0 pb-0 date-picker">
                                        <v-row>
                                            <v-col sm="5" class="py-0">
                                                <label class="mb-0">{{ $t("FROM_DATE") }}</label>
                                                <date-picker :model.sync="editedItem.startBookingDate" :disabled="!editedItem.bookingSession" :min="currentDatePicker" :error.sync="error.startBookingDate.error" />
                                            </v-col>
                                            <v-col sm="5" class="py-0">
                                                <label class="mb-0">{{ $t("TO_DATE") }}</label>
                                                <date-picker :model.sync="editedItem.endBookingDate" :min="editedItem.startBookingDate" :disabled="!editedItem.bookingSession" :error.sync="error.endBookingDate.error" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col>
                                <label>{{ $t("WHAT_DOES_PAYMENT_POLICY_APPLY") }}</label>
                                <v-row>
                                    <v-col md="12" class="pt-0">
                                        <v-radio-group row v-model="editedItem.stayingSession" class="mt-2">
                                            <v-radio color="indigo darken-3" :label="$t('ALWAYS')" :value="false"></v-radio>
                                            <v-radio color="indigo darken-3" :label="$t('IN_PERIOD')" :value="true"></v-radio>
                                        </v-radio-group>
                                    </v-col>
                                    <v-col md="12" class="pt-0 date-picker">
                                        <v-row>
                                            <v-col sm="5" class="py-0">
                                                <label class="mb-0">{{ $t("FROM_DATE") }}</label>
                                                <date-picker :model.sync="editedItem.startStayingDate" :disabled="!editedItem.stayingSession" :min="currentDatePicker" :error.sync="error.startStayingDate.error" />
                                            </v-col>
                                            <v-col sm="5" class="py-0">
                                                <label class="mb-0">{{ $t("TO_DATE") }}</label>
                                                <date-picker :model.sync="editedItem.endStayingDate" :min="editedItem.startStayingDate" :disabled="!editedItem.stayingSession" :error.sync="error.endStayingDate.error" />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <p class="border-bottom pt-3"></p>
                    </div>
                    <!-- start tab -->
                    <v-tabs v-model="tab" class="pl-0">
                        <v-tab v-for="name in languages" :key="name">{{ name }}</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab">
                        <v-tab-item v-for="code in codeLangs" :key="code">
                            <v-row>
                                <v-col sm="12" class="pb-0">
                                    <label class="label-input">{{ $t("POLICY_SUMMARY") }}</label>
                                    <v-textarea v-model="editedItem.depositI18n.find(x => x.lang == code).description" outlined
                                    :rows="6"
                                    counter="3000"
                                    maxlength="3000"
                                    class="input-counter"
                                    :rules="ruleDescNotRequired"
                                    dense></v-textarea>
                                </v-col>
                            </v-row>
                        </v-tab-item>
                    </v-tabs-items>
                    <!-- end tab -->
                    <hr>
                    <div class="mr-3 pb-3 d-flex align-center" style="max-width: 350px">
                        <label class="text-nowrap mr-2">{{
                        $t("CHANNEL_APPLY")
                        }}</label>
                        <v-autocomplete dense outlined item-text="text" item-value="value" :items="listOtaConnectGlobal"
                        v-model="selectedOTAGlobalAndCtrip" chips multiple style="width: 270px;" disabled>
                        <template v-slot:selection="{ item, index }">
                            <v-chip color="primary" v-bind="item.attrs" :input-value="item.selected" >
                            <span>{{ item.text }}</span>
                            </v-chip>
                        </template>
                        </v-autocomplete>
                    </div>
                </v-col>
            </v-row>
        </v-form>

        <v-row>
            <v-col sm="12" class="pt-0">
                <div class="btn-bottom mt-5">
                    <v-btn depressed class="mr-5" @click="back">{{ $t("BACK") }}</v-btn>
                    <v-btn color="primary" class="pl-10 pr-10" @click="save">{{ $t("SAVE") }}</v-btn>
                </div>
            </v-col>
        </v-row>
    </div>
</div>
</template>

<script>
import DatePicker from "@/components/Utils/DatePicker.vue";
import {
    _alert
} from "@/_helpers/function.js";
import {
    service
} from "@/_services/HotelSetting/payment-policy.service.js";
import moment from "moment";

export default {
    components: {
        "date-picker": DatePicker,
    },
    data() {
        return {
            sysLang: this.$i18n.locale || "vi",
            amountOptionsVi: {
                locale: "vi",
                length: 9,
                precision: 0
            },
            amountOptionsEn: {
                locale: "vi",
                length: 9,
                precision: 2
            },
            currentDatePicker: moment()
                .startOf("day")
                .format("YYYY-MM-DD"),
            rules: {
                required: value => !!value || this.$t("_REGISTER.REQUIRED_FIELD"),
                number: value => parseFloat(value) > 0 || this.$t("DATA_INPUT_MUST_BE_GREATER_THAN_0"),
                select: value => value != null || this.$t("_REGISTER.REQUIRED_FIELD"),
                maxPercent: value => value <= 100 || this.$t("DATA_INPUT_MAX_100_PERCENT"),
                maxNight: value => value <= 10 || this.$t("DATA_INPUT_MAX_10_NIGHT"),
                time: value => value <= 24 || this.$t("DATA_INPUT_MAX_24_HOUR"),
            },
            editedItem: {
                cutOfDate: 0,
                paymentDay: 0,
                amount: 1,
                nameVi: null,
                stayingSession: false,
                bookingSession: false,
                chargeType: 1,
                descriptionVi: null,
                endBookingDate: null,
                endStayingDate: null,
                startBookingDate: null,
                startStayingDate: null,
                paymentDayType: 4,
                cutOfDateType: 2,
                depositI18n: []
            },
            select: {
                unit: [{
                    value: 2,
                    text: this.$t("PRICE_PER_NIGHT")
                }, {
                    value: 1,
                    text: this.$t("PERCENT_BOOKING")
                }, {
                    value: 0,
                    text: this.$t('_BOOKING_DETAIL.SERVICE.COST')
                }],
                cusOfDateTypeOption: [{
                        value: 0,
                        text: this.$t("BEFORE_CHECKOUT_DATE"),
                        text_vi: 'Trước ngày trả phòng',
                        text_en: 'Before check-out date',
                        text_ja: 'チェックアウト前',
                        text_zh: '退房前',
                        text_ko: '퇴실 전'
                    },
                    {
                        value: 1,
                        text: this.$t("BEFORE_CHECKIN_DATE"),
                        text_vi: 'Trước ngày nhận phòng',
                        text_en: 'Before check-in date',
                        text_ja: 'チェックイン前',
                        text_zh: '入住前',
                        text_ko: '체크인 전'
                    },
                    {
                        value: 2,
                        text: this.$t('ON_THE_DATE_OF_BOOKING'),
                        text_vi: 'Vào ngày đặt phòng',
                        text_en: 'On the date of booking',
                        text_ja: '予約日に',
                        text_zh: '在预订当天',
                        text_ko: '예약일에'
                    },
                    // { value: 3, text: 'Trước giờ nhận phòng' }, 
                    {
                        value: 5,
                        text: this.$t('ON_THE_DAY_OF_CHECK_OUT'),
                        text_vi: 'Vào ngày trả phòng',
                        text_en: 'On the day of check out',
                        text_ja: 'チェックアウト日に',
                        text_zh: '退房当天',
                        text_ko: '체크아웃 당일에'
                    },
                    {
                        value: 6,
                        text: this.$t('ON_THE_DAY_OF_CHECK_IN'),
                        text_vi: 'Vào ngày nhận phòng',
                        text_en: 'On the day of check in',
                        text_ja: 'チェックイン日に',
                        text_zh: '入住当天',
                        text_ko: '체크인 당일에'
                    },
                ],
                paymentDayTypeOption: [{
                        value: 0,
                        text: this.$t("BEFORE_CHECKOUT_DATE"),
                        text_vi: 'Trước ngày trả phòng',
                        text_en: 'Before check-out date',
                        text_ja: 'チェックアウト日前に',
                        text_zh: '退房日前',
                        text_ko: '체크아웃 전'
                    },
                    {
                        value: 1,
                        text: this.$t("BEFORE_CHECKIN_DATE"),
                        text_vi: 'Trước ngày nhận phòng',
                        text_en: 'Before check-in date',
                        text_ja: 'チェックイン日前',
                        text_zh: '入住日前',
                        text_ko: '체크인 전'
                    },
                    // { value: 2, text: 'Trước giờ trả phòng' }, 
                    // { value: 3, text: 'Trước giờ nhận phòng' }, 
                    {
                        value: 4,
                        text: this.$t('ON_THE_DAY_OF_CHECK_OUT'),
                        text_vi: 'Vào ngày trả phòng',
                        text_en: 'On the day of check out',
                        text_ja: 'チェックアウト日に',
                        text_zh: '退房当天',
                        text_ko: '체크아웃 당일에'
                    },
                    {
                        value: 5,
                        text: this.$t('ON_THE_DAY_OF_CHECK_IN'),
                        text_vi: 'Vào ngày nhận phòng',
                        text_en: 'On the day of check in',
                        text_ja: 'チェックイン日に',
                        text_zh: '入住当天',
                        text_ko: '체크인 당일에'
                    },
                ]
            },
            forfeitError: {
                value: null,
                unit: null
            },
            paymentOptions: [{
                    value: 1,
                    text: this.$t("PAYMENT_BEFORE_DAY_CHECKIN_DATE")
                },
                {
                    value: 2,
                    text: this.$t("PAYMENT_BEFORE_CHECKOUT_DATE")
                },
                {
                    value: 3,
                    text: this.$t("PREPAYMENT_BEFORE_CHECKIN_DATE")
                }
            ],
            isFromCheckout: [{
                    value: false,
                    text: this.$t("BEFORE_CHECKIN_DATE")
                },
                {
                    value: true,
                    text: this.$t("BEFORE_CHECKOUT_DATE")
                },
            ],
            paymentDay: 1,
            error: {
                startStayingDate: {
                    error: null,
                    message: this.$t("_REGISTER.REQUIRED_FIELD"),
                    required: true
                },
                endStayingDate: {
                    error: null,
                    message: this.$t("_REGISTER.REQUIRED_FIELD"),
                    required: true
                },
                startBookingDate: {
                    error: null,
                    message: this.$t("_REGISTER.REQUIRED_FIELD"),
                    required: null
                },
                endBookingDate: {
                    error: null,
                    message: this.$t("_REGISTER.REQUIRED_FIELD"),
                    required: null
                },
            },
            ruleAmount: null,

            //

            paymentRequired: true,
            policySummary: [],
            paymentDayTypeOption: [{
                    value: 0,
                    text: this.$t("BEFORE_CHECKOUT_DATE"),
                    text_vi: 'Trước ngày trả phòng',
                    text_en: 'Before check-out date',
                },
                {
                    value: 1,
                    text: this.$t("BEFORE_CHECKIN_DATE"),
                    text_vi: 'Trước ngày nhận phòng',
                    text_en: 'Before check-in date',
                },
                // { value: 2, text: 'Trước giờ trả phòng' }, 
                // { value: 3, text: 'Trước giờ nhận phòng' }, 
                {
                    value: 4,
                    text: this.$t('ON_THE_DAY_OF_CHECK_OUT'),
                    text_vi: 'Vào ngày trả phòng',
                    text_en: 'On the day of check out',
                },
                {
                    value: 5,
                    text: this.$t('ON_THE_DAY_OF_CHECK_IN'),
                    text_vi: 'Vào ngày nhận phòng',
                    text_en: 'On the day of check in',
                },
            ],
            tab: null,
			languages: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.name) : [],
      		codeLangs: JSON.parse(localStorage.getItem('listLangs')).length > 0 ? JSON.parse(localStorage.getItem('listLangs')).map(item => item.languageCode) : [],
			oldEditedItem: {},
            timeout: null,
            forceRenderKey: 0,
        };
    },
    async created() {
        this.codeLangs.forEach(e => {
			this.policySummary.push({
				description: null,
				lang: e,
				name: null,
			})
		});
        this.currency = this.priceOptionsVi.suffix;
        let id = this.$route.params.id;
        if (id != 0) {
            let params = {
                limit: 0,
                offset: 0
            };
            await service.get(params).then(res => {
                params = {
                    limit: res.total,
                    offset: 0
                };
            });
            await service.get(params).then(res => {
                this.editedItem = Object.assign({}, res.data.find(x => x.id == id));
                this.editedItem.depositI18n.forEach(e => {
                    e.description = e.description.replace(/[\t\n]/g, " ");
                    e.description = e.description.replace(/\s+/g, " ");
                });
                this.oldEditedItem = JSON.parse(JSON.stringify(this.editedItem));
                this.paymentRequired = this.editedItem.cutOfDateType === 2;
            });
        } else {
            this.editedItem = {
                cutOfDate: 0,
                paymentDay: 0,
                amount: 1,
                nameVi: null,
                stayingSession: false,
                bookingSession: false,
                chargeType: 1,
                descriptionVi: null,
                endBookingDate: null,
                endStayingDate: null,
                startBookingDate: null,
                startStayingDate: null,
                paymentDayType: 4,
                cutOfDateType: 2,
                depositI18n: [...this.policySummary]
            };
        }

        // if ( this.editedItem.chargeType == 0 ) {
        // 	this.amountOptions.length = 2;
        // } 
        // if ( this.editedItem.chargeType == 1 ) {
        // 	this.amountOptions.length = 3;
        // }
        // if ( this.editedItem.chargeType == 2 ) {
        // 	this.amountOptions.length = 9;
        // }
    },
    mounted() {
        document
            .querySelector(".v-tab.v-tab--active")
            .classList.remove("v-tab--active");
        document
            .querySelector(".v-tab[tabIndex='1']")
            .classList.add("v-tab--active");
    },
    watch: {
        paymentRequired() {
            if (this.paymentRequired === true) {
                this.editedItem.cutOfDate = 0; // ngày đặt cọc
                this.editedItem.cutOfDateType = 2; // ngày khách xuống tiền lần 1
            }
        },
        editedItem: {
            handler(value) {
                if (value.chargeType == 2 || value.chargeType == 1) {
                    this.amountOptionsEn.precision = 0;
                    if (value.chargeType == 1) {
                        this.amountOptionsEn.length = 3;
                        this.amountOptionsVi.length = 3;
                    } else if (value.chargeType == 2) {
                        this.amountOptionsEn.length = 2;
                        this.amountOptionsVi.length = 2;
                    }
                } else {
                    this.amountOptionsEn.precision = 2;
                    this.amountOptionsVi.length = 9;
                    this.amountOptionsEn.length = 6;
                }

                let textCusOfVi = '';
                let textCusOfDefault = '';
                let textPaymentVi = '';
                let textPaymentDefault = '';
                if (value.cutOfDateType === 2) { // vao ngay dat
                    if ((this.editedItem.chargeType === 1 && +this.editedItem.amount !== 100) || this.editedItem.chargeType !== 1) {
                        switch (this.editedItem.chargeType) {
                            case 1:
                                textCusOfVi = `Khách hàng cần thanh toán ${this.editedItem.amount}% giá trị đặt phòng vào ngày đặt phòng.`;
                                textCusOfDefault = `Guests need to pay ${this.editedItem.amount}% of the reservation value on the date of booking.`;
                                break;
                            default:
                                textCusOfVi = `Khách hàng cần thanh toán ${this.editedItem.chargeType === 0 ? this.formatCurrency(this.editedItem.amount) : this.editedItem.amount} ${this.editedItem.chargeType === 0 ? this.usedCurrency : 'đêm'} vào ngày đặt phòng.`;
                                textCusOfDefault = `Customer need to pay the ${this.editedItem.chargeType === 0 ? this.formatCurrency(this.editedItem.amount) : this.editedItem.amount} ${this.editedItem.chargeType === 0 ? this.usedCurrency : 'night'} on the booking date.`;
                                break;
                        }
                        textPaymentVi = ` Số tiền còn lại cần thanh toán ${this.select.paymentDayTypeOption.filter(e => e.value === this.editedItem.paymentDayType)[0].text_vi.toLowerCase()} ${[0, 1].includes(this.editedItem.paymentDayType) ? `${this.editedItem.paymentDay} ngày`: ''}`;
                        textPaymentDefault = `The remaining amount will be paid ${this.select.paymentDayTypeOption.filter(e => e.value === this.editedItem.paymentDayType)[0].text_en.toLowerCase()} ${[0, 1].includes(this.editedItem.paymentDayType) ? `${this.editedItem.paymentDay} date`: ''}`;
                    } else {
                        textCusOfVi = `Khách hàng cần thanh toán toàn bộ số tiền vào ngày đặt phòng.`;
                        textCusOfDefault = `Full payment is required on the day of booking.`;
                    }
                } else { // khac ngay dat
                    if (((this.editedItem.chargeType === 1 && +this.editedItem.amount !== 100) || this.editedItem.chargeType !== 1) && this.editedItem.cutOfDateType !== 5) {
                        switch (this.editedItem.chargeType) {
                            case 1:
                                textCusOfVi = `Khách hàng cần thanh toán ${this.editedItem.amount}% giá trị đặt phòng ${this.select.cusOfDateTypeOption.filter(e => e.value === this.editedItem.cutOfDateType)[0].text_vi.toLowerCase()} ${[0, 1].includes(this.editedItem.cutOfDateType) ? `${this.editedItem.cutOfDate} ngày`: ''}.`;
                                textCusOfDefault = `Customers need to pay ${this.editedItem.amount}% of the booking value ${this.select.cusOfDateTypeOption.filter(e => e.value === this.editedItem.cutOfDateType)[0].text_en.toLowerCase()} ${[0, 1].includes(this.editedItem.cutOfDateType) ? `${this.editedItem.cutOfDate} date`: ''}.`;
                                break;
                            default:
                                textCusOfVi = `Khách hàng cần thanh toán ${this.editedItem.chargeType === 0 ? this.formatCurrency(this.editedItem.amount) : this.editedItem.amount} ${this.editedItem.chargeType === 0 ? this.usedCurrency : 'đêm'} ${this.select.cusOfDateTypeOption.filter(e => e.value === this.editedItem.cutOfDateType)[0].text_vi.toLowerCase()} ${[0, 1].includes(this.editedItem.cutOfDateType) ? `${this.editedItem.cutOfDate} ngày`: ''}.`;
                                textCusOfDefault = `Customer need to pay the ${this.editedItem.chargeType === 0 ? this.formatCurrency(this.editedItem.amount) : this.editedItem.amount} ${this.editedItem.chargeType === 0 ? this.usedCurrency : 'night'} ${this.select.cusOfDateTypeOption.filter(e => e.value === this.editedItem.cutOfDateType)[0].text_en.toLowerCase()} ${[0, 1].includes(this.editedItem.cutOfDateType) ? `${this.editedItem.cutOfDate} date`: ''}.`;
                                break;
                        }
                        textPaymentVi = ` Số tiền còn lại cần thanh toán ${this.select.paymentDayTypeOption.filter(e => e.value === this.editedItem.paymentDayType)[0].text_vi.toLowerCase()} ${[0, 1].includes(this.editedItem.paymentDayType) ? `${this.editedItem.paymentDay} ngày`: ''}`;
                        textPaymentDefault = `The remaining amount will be paid ${this.select.paymentDayTypeOption.filter(e => e.value === this.editedItem.paymentDayType)[0].text_en.toLowerCase()} ${[0, 1].includes(this.editedItem.paymentDayType) ? `${this.editedItem.paymentDay} date`: ''}`;

                    } else {
                        textCusOfVi = `Khách hàng cần thanh toán toàn bộ số tiền ${this.select.cusOfDateTypeOption.filter(e => e.value === this.editedItem.cutOfDateType)[0].text_vi.toLowerCase()} ${[0, 1].includes(this.editedItem.cutOfDateType) ? `${this.editedItem.cutOfDate} ngày`: ''}.`;
                        textCusOfDefault = `Customer needs to pay the full amount ${this.select.cusOfDateTypeOption.filter(e => e.value === this.editedItem.cutOfDateType)[0].text_en.toLowerCase()} ${[0, 1].includes(this.editedItem.cutOfDateType) ? `${this.editedItem.cutOfDate} date`: ''}.`;
                    }
                }
                if (this.editedItem.depositI18n.length > 0) {
					this.editedItem.depositI18n.forEach(item => {
						if (!item.description) {
							this.codeLangs.forEach(e => {
								this.policySummary.forEach(ele => {
									if (e === 'vi' && e === ele.lang) {
										ele.description = textCusOfVi + textPaymentVi;
										ele.name = value.nameVi
									} else {
										if(e === ele.lang) {
											ele.description = textCusOfDefault + textPaymentDefault;
											ele.name = value.nameVi
										}
									}
								});
							});
						}
					});
				}
                if (this.oldEditedItem.amount !== value.amount || this.oldEditedItem.chargeType !== value.chargeType || this.oldEditedItem.paymentDay !== value.paymentDay || this.oldEditedItem.paymentDayType !== value.paymentDayType) {
					this.codeLangs.forEach(e => {
						this.policySummary.forEach(ele => {
							if (e === 'vi' && e === ele.lang) {
								ele.description = textCusOfVi + textPaymentVi;
								ele.name = value.nameVi
							} else {
								if(e === ele.lang) {
									ele.description = textCusOfDefault + textPaymentDefault;
									ele.name = value.nameVi
								}
							}
						});
					});
					this.editedItem.depositI18n = [...this.policySummary];
				}
				this.oldEditedItem = JSON.parse(JSON.stringify(value));
            },
            deep: true
        }
    },
    methods: {
        changeCusOfDateType() {
            // { value: 0, text: 'Trước ngày trả phòng' }, 
            // { value: 1, text: 'Trước ngày nhận phòng' }, 
            // { value: 2, text: 'Trước giờ trả phòng' }, 
            // { value: 3, text: 'Trước giờ nhận phòng' }, 
            // { value: 4, text: 'Vào ngày trả phòng' },
            // { value: 5, text: 'Vào ngày nhận phòng' },
            const arrTypePayment = this.select.paymentDayTypeOption;
            switch (this.editedItem.cutOfDateType) {
                case 0: // truoc ngay tra
                    this.paymentDayTypeOption = arrTypePayment.filter(e => [4].includes(e.value));
                    break;
                case 1: // trc ngay nhan
                    this.paymentDayTypeOption = arrTypePayment.filter(e => [4, 0, 5].includes(e.value));
                    break;
                case 2: // vao ngay dat
                    this.paymentDayTypeOption = arrTypePayment.filter(e => [1, 0, 5, 4].includes(e.value));
                    break;
                case 3: // trước giờ trả
                    this.paymentDayTypeOption = arrTypePayment.filter(e => [4].includes(e.value));
                    break;
                case 4: // trước giờ nhận
                    this.paymentDayTypeOption = arrTypePayment.filter(e => [6, 0, 4].includes(e.value));
                    break;
                case 5: // vao ngay trả
                    this.paymentDayTypeOption = arrTypePayment.filter(e => [4].includes(e.value));
                    this.editedItem.amount = 0;
                    break;
                case 6: // vao ngay nhận
                    this.paymentDayTypeOption = arrTypePayment.filter(e => [0, 4].includes(e.value));
                    break;
                default:
                    this.paymentDayTypeOption = arrTypePayment;
            }
            this.editedItem.paymentDayType = this.paymentDayTypeOption[0].value;
        },
        back() {
            this.$router.back();
        },
        async save() {

            if (!this.editedItem.startStayingDate && this.editedItem.stayingSession) {
                this.error.startStayingDate.error = true;
            } else {
                this.error.startStayingDate.error = false;
            }

            if (!this.editedItem.endStayingDate && this.editedItem.stayingSession) {
                this.error.endStayingDate.error = true;
            } else {
                this.error.endStayingDate.error = false;
            }

            if (!this.editedItem.startBookingDate && this.editedItem.bookingSession) {
                this.error.startBookingDate.error = true;
            } else {
                this.error.startBookingDate.error = false;
            }

            if (!this.editedItem.endBookingDate && this.editedItem.bookingSession) {
                this.error.endBookingDate.error = true;
            } else {
                this.error.endBookingDate.error = false;
            }

            this.editedItem.depositI18n.forEach(item => {
                if (!item.name) {
                    this.policySummary.forEach(ele => {
                        ele.name = this.editedItem.nameVi
                    });
                }
            });

            let form_validate = this.$refs.form.validate();

            if (this.error.startStayingDate.error || this.error.endStayingDate.error || this.error.startBookingDate.error || this.error.endBookingDate.error) {
                this.$store.commit("alert/display", {
                    message: this.$t("MISSING_FIELD"),
                    error: true,
                    success: false
                });
                return false;
            }

            if (this.editedItem.id && form_validate) {
                await service.update(this.editedItem).then(res => {
                    _alert(res, this.$t(res.data));
                    if (res.responseCode != 0) {
                        // element.disabled = false;
                    }
                });
            } else if (form_validate) {
                await service.insert(this.editedItem).then(res => {
                    _alert(res, this.$t(res.data), false);
                    let vm = this;
                    setTimeout(function () {
                        vm.$router.push({
                            name: "listOfPayments"
                        });
                    }, 1000);
                });
            }
        },
        changeRuleAmount() {
            this.editedItem.amount = null;
        },
        numberFormat(x, lang) {
            if (x) {
				return new Intl.NumberFormat(this.sysLang, {
					style: 'decimal',
					minimumFractionDigits: lang == 'VND' ? 0 : 2,
					maximumFractionDigits: lang == 'VND' ? 0 : 2,
				}).format(x)
			}
        },
    },
    computed: {
        pricePolicy: {
            get: function () {
                return this.convertDecimalViaLocal(this.editedItem.amount);
            },
            set: function (newValue) {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                const value = this.setCurrency(newValue);
                this.editedItem.amount = value;
                if (value == this.editedItem.amount) {
                    this.forceRenderKey++;
                    this.$nextTick(() => {
                        if (this.$refs.pricePolicy && this.editedItem.chargeType == 0) {
                            this.$refs.pricePolicy.focus();
                        }
                    });
                }
                }, this.timeOutChange(newValue));
            }
        },
    }
};
</script>
